import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
	selector: 'cpi-toggle-switch',
	templateUrl: './toggle-switch.component.html',
	styleUrl: './toggle-switch.component.scss',
})
export class ToggleSwitchComponent implements OnChanges {
	@Input()
	size = 12;

	//Visualmente inverte o toggle se você quiser que o ativo seja negativo.
	@Input()
	invertToggle: boolean;

	@Input() switchOn = false;
	@Output() switchOnChange = new EventEmitter<boolean>();

	ngOnChanges(changes: SimpleChanges): void {
		if (changes?.size && changes.size.currentValue < 1) this.size = 12;
	}

	changeSwitch(): void {
		this.switchOn = !this.switchOn;
		this.switchOnChange.emit(this.switchOn);
	}
}
